const Component = () => import('./MyPlan');

export { Component };
